import React, { useState, useEffect } from "react";
import * as Images from "../../../../utilities/images";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  getCategories,
  getClassDetails,
  updateClassDetails,
  uploadFiles,
} from "../../../../redux/slices/admin";
import { toast } from "react-toastify";
import moment from "moment";
import { Spinner } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import ApiPath from "../../../../constants/apiPath";
import { ApiClient } from "../../../../utilities/api";

const EditClass = () => {
  const [videoLoading, setVideoLoading] = useState(false);
  const [videoLoadingPercent, setVideoLoadingPercent] = useState(0);
  const toastId = React.useRef(null);
  const { id } = useParams();
  const [type, setType] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [date, setDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [duration, setDuration] = useState("");
  const [videoThumbnail, setVideoThumbnail] = useState("");
  const [thumbnailImage, setThumbnailImage] = useState(null);
  const [classVideo, setClassVideo] = useState(null);
  const [previewClassVideo, setPrviewClassVideo] = useState(null);
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [accesslevels, setAccesslevels] = useState("");
  const [categoryTitle, setCategoryTitle] = useState("");
  const [instructors, setInstructors] = useState([
    { full_name: "", img: "", file: null, id: null, errorId: Math.random() },
  ]);
  const [errorInstrctors, setErrorInstrctors] = useState([]);
  const [classResponseData, setClassResponseData] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [newFileName, setNewFileName] = useState("");
  const [fileExtension, setFileExtension] = useState("");
  const [videoKey, setVideoKey] = useState(0);
  const [loader, setLoader] = useState(false);

  const accesLevels = [
    { id: 1, title: "Free" },
    { id: 2, title: "Paid" },
  ];

  const handleVideoError = (event) => {
    const url1 =
      "https://d1u9rinm8sz0kp.cloudfront.net/" +
      newFileName +
      "/" +
      fileExtension +
      "/" +
      newFileName +
      "." +
      fileExtension;
    // setTimeout(() => {
    setPrviewClassVideo(null);
    setClassVideo(null);
    setVideoKey((prevKey) => prevKey + 1);
    // }, 30000);
    setLoader(true);

    // Additional error handling logic, if needed
  };

  const handleVideoSuccess = () => {
    setLoader(false);
    // Additional success handling logic, if needed
  };
  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const list = [...instructors];
    const item = list[index];
    list[index] = {
      full_name: value,
      img: item.img,
      file: item.file,
      id: item.id,
      errorId: item.errorId,
    };
    setInstructors(list);
    setInstructorErrorsData(value, item, "instrctors", "instrctors");
  };

  const setInstructorErrorsData = (value, item, errorType, type) => {
    const val = value.trim();
    const errorIndex = errorInstrctors.findIndex(
      (x) => x.errorId === item.errorId && x.errorType === errorType
    );
    const errorObjData = getErrorObj(val, item, type, errorType);
    const errorsInstrctorsCopy = [...errorInstrctors];

    if (errorObjData !== null) {
      if (errorIndex >= 0) {
        errorsInstrctorsCopy[errorIndex] = errorObjData;
        setErrorInstrctors(errorsInstrctorsCopy);
      } else {
        errorsInstrctorsCopy.push(errorObjData);
        setErrorInstrctors(errorsInstrctorsCopy);
      }
    } else {
      if (errorIndex >= 0) {
        errorsInstrctorsCopy.splice(errorIndex, 1);
        setErrorInstrctors(errorsInstrctorsCopy);
      }
    }
  };

  const handleAddInput = () => {
    setInstructors([
      ...instructors,
      { full_name: "", img: "", file: null, id: null, errorId: Math.random() },
    ]);
  };

  const handleRemoveInput = (index) => {
    const list = [...instructors];
    const listData = list[index];
    list.splice(index, 1);
    setInstructors(list);
    removeInstrctorError(listData, "instrctors");
    removeInstrctorError(listData, "Image");
  };

  const removeInstrctorError = (listData, errorType) => {
    const errorIndex = errorInstrctors.findIndex(
      (x) => x.errorId === listData.errorId && x.errorType === errorType
    );
    if (errorIndex >= 0) {
      const errorsInstrctorCopy = [...errorInstrctors];
      errorsInstrctorCopy.splice(errorIndex, 1);
      setErrorInstrctors(errorsInstrctorCopy);
    }
  };

  const getErrorObj = (val, item, type, errorType) => {
    let letterVal = /^[a-zA-Z\s]*$/;

    if (errorType === "instrctors") {
      if (val === "" || val === undefined || val === null) {
        return {
          errorId: item.errorId,
          errorMessage: `${type} Can not be empty`,
          errorType: errorType,
        };
      }
      if (!val.match(letterVal)) {
        return {
          errorId: item.errorId,
          errorMessage: `${type} must have alphabets only`,
          errorType: errorType,
        };
      }
      if (val.length < 3) {
        return {
          errorId: item.errorId,
          errorMessage: `${type} must have minimum 3 charecters`,
          errorType: errorType,
        };
      }
      if (val.length > 25) {
        return {
          errorId: item.errorId,
          errorMessage: `${type} must have maximum 25 charecters`,
          errorType: errorType,
        };
      }
    }

    if (errorType === "Image") {
      if (val === "" || val === undefined || val === null) {
        return {
          errorId: item.errorId,
          errorMessage: `${errorType} Can not be empty`,
          errorType: errorType,
        };
      }
    }

    return null;
  };

  const handleSaveFiles = (file, index) => {
    let params = {
      uploadfile: file,
    };
    setLoading(true);
    dispatch(
      uploadFiles({
        ...params,
        cb(res) {
          setLoading(false);
          if (res.status) {
            const list = [...instructors];
            const item = list[index];
            list[index] = {
              full_name: item.full_name,
              id: item.id,
              img: res?.data?.data?.file_url,
              file: res?.data?.data?.file_name,
            };
            setInstructors(list);
            setInstructorErrorsData(
              res?.data?.data?.file_name,
              item,
              "Image",
              "Image"
            );
            //toast.success("instructor Image updated");
          } else {
            navigate("/");
          }
        },
      })
    );
  };

  const handleUploadImage = (e, index) => {
    const file = e.target.files[0];
    if (!file.name.match(/\.(jpg|png|jpeg|)$/)) {
      toast.error("Please select a valid instructor image.");
      return false;
    }
    const list = [...instructors];
    const item = list[index];

    if (file) {
      handleSaveFiles(file, index);
    }
  };

  const classDetails = () => {
    let params = {
      id: id,
    };
    dispatch(
      getClassDetails({
        ...params,
        cb(res) {
          if (res?.data) {
            setClassResponseData(res?.data?.data);
            setType(res?.data?.data?.type);
            setTitle(res?.data?.data?.title);
            setDescription(res?.data?.data?.description);
            setCategoryId(res?.data?.data?.category_id);
            setCategoryTitle(res?.data?.data?.category_title);
            setDate(moment(res?.data?.data?.date).format("YYYY-MM-DD"));
            setSelectedTime(res?.data?.data?.time);
            //setRecipe_video(res?.data?.data?.recipe_video);
            setDuration(res?.data?.data?.duration);
            setVideoThumbnail(res?.data?.data?.thumbnail_image);
            setPrviewClassVideo(res?.data?.data?.class_video);
            setClassVideo(res?.data?.data?.class_video);
            // setPlanIds(
            //   res?.data?.data?.accesslevels.map((plan) => {
            //     return {
            //       plan_id: plan.plan_id,
            //     };
            //   })
            // );
            setAccesslevels(res?.data?.data?.access_level);
            setInstructors(
              res?.data?.data?.instructors.map((inst) => {
                const imgData = inst.img_url.split("/");
                return {
                  full_name: inst.full_name,
                  img: inst.img_url,
                  file: imgData[imgData.length - 1],
                  id: inst.id,
                  errorId: Math.random(),
                };
              })
            );
            // getAllPlans(res?.data?.data?.accesslevels);
            //setClass_video(res?.data?.data?.class_video);
          } else {
            toast.error("something went wrong");
          }
        },
      })
    );
  };

  function hasEmptyValues(arr) {
    for (const item in arr) {
      const obj = arr[item];
      if (obj.full_name == "" || obj.full_name?.length < 3 || obj.img == "") {
        return true;
      }
    }
    return false; // No empty values found
  }

  const currentDate = moment();
  const localTime = moment(selectedTime, "HH:mm");
  const combinedDateTime = moment(currentDate).set({
    hour: localTime.hour(),
    minute: localTime.minute(),
  });
  const utcTime = combinedDateTime.utc();
  const utcTimeStr = utcTime.format("YYYY-MM-DDTHH:mm:ss[Z]");

  const updateClasses = (e) => {
    e.preventDefault();
    let letterVal = /^[a-zA-Z\s]*$/;

    if (accesLevels == "") {
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error("Please select access level");
      }
      return;
    }
    if (!title) {
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error("Please enter title");
      }
      return;
    } else if (title.length <= 2) {
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error("Title must have minimum 3 character");
      }
      return;
    } else if (title.length > 50) {
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error(
          "Title must have maximun 50 characters only"
        );
      }
      return;
    } else if (!title.match(letterVal)) {
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error(
          "Please enter only alphabet characters in title"
        );
      }
      return;
    } else if (!description) {
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error("Please enter description");
      }
      return;
    } else if (type == 1) {
      if (!selectedTime) {
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.error("Please select time");
        }
        return;
      }
    } else if (type === 1) {
      if (!duration) {
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.error("Please add class duration");
        }
        return;
      }
    } else if (description.length <= 2) {
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error(
          "Description must have minimum 3 characters"
        );
      }
      return;
    } else if (!categoryId) {
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error("Please select category type");
      }
      return;
    } else if (!videoThumbnail) {
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error("Please add video thumbnail");
      }
      return;
    } else if (instructors.length > 0) {
      const checkIns = hasEmptyValues(instructors);
      if (checkIns) {
        toast.error(
          "Image must be added with all instructor name and instructor name must be greater than 3 characters"
        );
        return;
      }
    } else if (!type == 1) {
      if (!previewClassVideo) {
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.error("Please add class video");
        }
        return;
      }
    }

    let params = {
      id: id,
      type: type,
      title: title,
      description: description,
      category_id: categoryId,
      access_level: accesslevels,
      date: utcTimeStr,
      time: selectedTime,
      duration: duration,
      instructors: instructors,
      class_video: previewClassVideo,
    };

    if (thumbnailImage !== null) {
      params = {
        ...params,
        video_thumbnail: thumbnailImage,
      };
    }
    setLoading(true);
    dispatch(
      updateClassDetails({
        ...params,
        cb(res) {
          setLoading(false);
          if (res.status) {
            navigate("/admin/classes");
          } else {
          }
        },
      })
    );
  };
  const handleKeyDown = (e) => {
    e.preventDefault();
  };
  const handleUploadClassVideo = async (e) => {
    const file = e.target.files[0];

    if (!file) {
      toast.error("Please select a file.");
      return false;
    }

    // Validate file type
    if (!file.name.match(/\.(mp4|webm|mov|avi)$/i)) {
      toast.error("Please select a valid video file (mp4, webm, mov, avi).");
      return false;
    }

    try {
      setVideoLoading(true);

      // Make API call
      const response = await ApiClient.postFilesData(ApiPath.adminApiPath.UPLOAD_VIDEO, { uploadfile: file }, {
        onUploadProgress: (progressEvent) => {
          const progressPercentage = Math.round(
            (progressEvent.loaded / progressEvent.total) * 100
          );
          setVideoLoadingPercent(progressPercentage);
        }
      });
      // Handle successful upload
      const videoUrl = response.data.data.file_url; // Adjust based on your API response
      setPrviewClassVideo(videoUrl);
      setClassVideo(URL.createObjectURL(file));

    } catch (error) {
      console.error("Error uploading video:", error);
      toast.error("Failed to upload video. Please try again.");
    } finally {
      setVideoLoading(false);
      setVideoLoadingPercent(0);
    }
  };
  const hanldeCrossClassVideo = () => {
    setClassVideo(null);
    setVideoKey(null);
    setPrviewClassVideo(null);
  };

  const getCategory = () => {
    dispatch(
      getCategories({
        cb(res) {
          if (res?.data) {
            setCategories(res?.data?.data);
          } else {
            toast.error("something went wrong");
          }
        },
      })
    );
  };
  useEffect(() => {
    classDetails();
    getCategory();
    window.scrollTo(0, 0);
    document.title = "Edit-class";
  }, []);

  const handleUploadVedioThumbnail = (e) => {
    const file = e.target.files[0];
    if (!file.name.match(/\.(jpg|png|jpeg|)$/)) {
      toast.error("Please select a valid image.");
      return false;
    }
    if (file) {
      setThumbnailImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setVideoThumbnail(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleCrossImage = () => {
    setThumbnailImage(null);
    setVideoThumbnail(null);
  };
  const handleCrossInstructorImage = (index) => {
    const list = [...instructors];
    let item = list[index];

    list[index] = { ...item, file: null, img: "" };
    setInstructors(list);
    setInstructorErrorsData(null, item, "Image", "Image");
  };

  // show only one toast at one time
  const showToast = (msg) => {
    if (!toast.isActive(toastId.current)) {
      toastId.current = toast.error(msg);
    }
  };

  return (
    <>
      <div className="AddClass">
        <div className="row mt-4">
          <div className="col-12">
            <div className="contentCommon">
              <div className="backBtn">
                <Link to={"/admin/classes"}>
                  <button className="btn colorPink px-0 pb-2">
                    <img
                      src={Images.rightarrowpink}
                      alt="arrow"
                      className="me-2"
                    />{" "}
                    Go to Back
                  </button>
                </Link>
                <h1 className="courseHeading font-28 pb-2">Edit Class</h1>
              </div>
              <form className="profileForm">
                <div className="row ">
                  <div className="mb-3 form-group col-md-12">
                    <label className="form-label pb-2">Class Type</label>
                    <div className="d-flex align-items-center">
                      <div className="me-4">
                        {type == 1 ? (
                          <label class="radioOuter">
                            Live Stream
                            <input
                              type="radio"
                              checked={type}
                              name="radio"
                              value={type}
                              onChange={(e) => setType(e.target.value)}
                            />
                            <span class="checkmark"></span>
                          </label>
                        ) : (
                          <label class="radioOuter">
                            Pre Recorded
                            <input
                              type="radio"
                              checked={type}
                              name="radio"
                              value={type}
                              onChange={(e) => setType(e.target.value)}
                            />
                            <span class="checkmark"></span>
                          </label>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="mb-3 form-group col-md-4">
                    <label
                      className="form-label pb-2"
                      htmlFor="exampleFormControlSelect1"
                    >
                      Access Type
                    </label>
                    <select
                      className="form-control text"
                      id="exampleFormControlSelect1"
                      required=""
                      value={accesslevels}
                      onChange={(e) => {
                        setAccesslevels(e.target.value);
                      }}
                    >
                      <option value="">Access type</option>
                      {accesLevels?.length > 0 ? (
                        <>
                          {accesLevels?.map((data) => {
                            return (
                              <option value={data?.id}>{data?.title}</option>
                            );
                          })}
                        </>
                      ) : (
                        ""
                      )}
                    </select>
                  </div>
                  <div className="mb-3 form-group col-md-12">
                    <label className="form-label pb-2">Title</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Update Title"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  </div>
                  <div className="mb-3 form-group col-md-12">
                    <label className="form-label pb-2">Class Overview</label>
                    <textarea
                      name=""
                      id=""
                      cols="30"
                      rows="10"
                      placeholder="Update Description"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      className="form-control"
                    ></textarea>
                  </div>
                  <div className="row">
                    <div className="mb-3 form-group col-md-6">
                      <label
                        className="form-label pb-2"
                        for="exampleFormControlSelect1"
                      >
                        Category Type
                      </label>
                      <select
                        className="form-control text"
                        id="exampleFormControlSelect1"
                        onChange={(event) => setCategoryId(event.target.value)}
                      >
                        <option>{categoryTitle}</option>
                        {categories.map((data, index) => (
                          <option key={index} value={data.id}>
                            {data.title}
                          </option>
                        ))}
                      </select>
                    </div>

                    {type == 1 ? (
                      <>
                        <div className="mb-3 form-group col-md-6">
                          <label className="form-label pb-2">Date</label>
                          <input
                            className="form-control text"
                            type="date"
                            placeholder=""
                            value={date}
                            selected={date}
                            min={moment(new Date()).format("YYYY-MM-DD")}
                            onChange={(e) => {
                              if (
                                moment(
                                  `${selectedTime} ${e.target.value}`,
                                  "YYYY-MM-DD HH:mm"
                                ).isBefore(moment()) &&
                                selectedTime
                              ) {
                                setSelectedTime("");
                                setDate(e.target.value);
                              } else {
                                setDate(e.target.value);
                              }
                            }}
                            onKeyDown={handleKeyDown}
                          />
                        </div>
                        <div className="mb-3 form-group col-md-6">
                          <label className="form-label pb-2">Time</label>
                          <input
                            className="form-control text"
                            type="time"
                            placeholder=" "
                            value={selectedTime}
                            onChange={(e) => {
                              if (
                                moment(
                                  `${date} ${e.target.value}`,
                                  "YYYY-MM-DD HH:mm"
                                ).isBefore(moment())
                              ) {
                                showToast("Please select future time");
                              } else {
                                setSelectedTime(e.target.value);
                              }
                            }}
                          />
                        </div>
                        <div className="mb-3 form-group col-md-6">
                          <label className="form-label pb-2">Duration</label>
                          <input
                            className="form-control text"
                            type="text"
                            placeholder=""
                            value={duration}
                            onChange={(e) => setDuration(e.target.value)}
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="IngredientsBox">
                  <div className="IngredientsBoxInner">
                    <div className="d-flex align-items-center">
                      <img src={Images.profile} alt="" />
                      <p className="medText m-0 ms-3">instructors</p>
                    </div>
                    <div className="">
                      <button
                        className="login-btn"
                        type="button"
                        onClick={handleAddInput}
                      >
                        Add
                      </button>
                      <span className="center-img">
                        <img src={Images.centerrectangle} alt="" />
                      </span>
                      <span className="circle-btn recipeBtnCircle">
                        <img src={Images.plussign} alt="" />
                      </span>
                    </div>
                  </div>
                  {instructors.map((item, idx) => {
                    return (
                      <>
                        <div
                          key={idx}
                          className="IngredientsBoxInner form-group-outer"
                        >
                          <div className="col-md-11">
                            <div className="addRecipeBox px-4">
                              <div className="addRecipeBoxInner d-inline">
                                <div className="recipeImgOuter recipeImgOuter-resp">
                                  {item?.img ? (
                                    <>
                                      {Boolean(item.img) ? (
                                        <div className="position-relative">
                                          <img
                                            src={
                                              Boolean(item.img)
                                                ? item.img
                                                : Images.addImage
                                            }
                                            className="img-fluid profileBig addProfileImg mx-0"
                                            alt=""
                                          />
                                          <img
                                            className="crossIcon addClassCross-resp"
                                            src={Images.whitecross}
                                            alt=""
                                            onClick={() =>
                                              handleCrossInstructorImage(idx)
                                            }
                                          />
                                        </div>
                                      ) : (
                                        ""
                                      )}{" "}
                                    </>
                                  ) : (
                                    <label
                                      className="choosenBtn"
                                      htmlFor={`actual-btn${idx}`}
                                    >
                                      <img src={Images.addImage} alt="" />
                                      <input
                                        type="file"
                                        accept="image/jpg,image/png,image/jpeg"
                                        id={`actual-btn${idx}`}
                                        className="custom-file-upload"
                                        onChange={(event) => {
                                          handleUploadImage(event, idx);
                                        }}
                                        hidden
                                      />
                                    </label>
                                  )}

                                  <div className="form-group InputOuter InputOuter-outer col-md-10">
                                    <input
                                      className="form-control"
                                      type="text"
                                      placeholder="Enter Instructor Name"
                                      value={item.full_name}
                                      onChange={(event) =>
                                        handleInputChange(idx, event)
                                      }
                                    />
                                    <div>
                                      {/* <p style={{ color: "red" }}>{imageError?.errorMessage}</p>
                                      <p style={{ color: "red" }}>{fullNameError?.errorMessage}</p> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="trashicon"
                            onClick={() => handleRemoveInput(idx)}
                          >
                            <img src={Images.trash} alt="" />
                          </div>
                        </div>
                      </>
                    );
                  })}
                </div>

                <h4 className="customLabel py-2">Add video Thumbnail </h4>

                <div className="mb-3 form-control col-md-12 fileBorder">
                  <input
                    type="file"
                    id="file-6"
                    className="inputfile inputfile-5"
                    accept="image/jpg,image/png,image/jpeg"
                    onChange={(e) => handleUploadVedioThumbnail(e)}
                  />

                  <div className="dnldFileOuter ThumbnailImgOuter">
                    {Boolean(videoThumbnail) ? (
                      <>
                        <img
                          src={videoThumbnail}
                          className="img-fluid w-100 mx-0"
                          alt="upload"
                          style={{ height: "200px", width: "100%", objectFit: 'contain' }}
                        />
                        <img
                          className="crossIcon"
                          src={Images.whitecross}
                          alt=""
                          onClick={(e) => handleCrossImage(e)}
                        />
                      </>
                    ) : (
                      <label for="file-6" className="labelNewCase">
                        <span className="file_span">
                          <img src={Images.downloadicon} alt="" />
                          <br />
                          <span className="colorPink">Browse</span> and drag and
                          drop the file. Upload JPG & PNG.
                        </span>
                      </label>
                    )}
                  </div>
                </div>
                {type == 2 ? (
                  <>
                    <h4 className="customLabel py-2">Upload Video </h4>
                    <div className="mb-3 form-control col-md-12 fileBorder">
                      <input
                        type="file"
                        id="file-15"
                        className="inputfile inputfile-5"
                        accept="video/mp4,video/webm"
                        onChange={(e) => handleUploadClassVideo(e)}
                      />

                      {videoLoading ? (
                        <>
                          <div className="text-center">
                            <Spinner
                              as="span"
                              animation="border"
                              role="status"
                              aria-hidden="true"
                              className="pinky"
                            />
                            <p className="colorPink">Uploading</p>
                          </div>

                          {videoLoadingPercent > 0 ? (
                            <ProgressBar
                              now={videoLoadingPercent}
                              label={`${videoLoadingPercent}%`}
                            />
                          ) : null}
                        </>
                      ) : (
                        <div
                          className={`  py-3  previewVedio ${videoKey ? "bgPreviewVideo" : ""
                            }`}
                        >
                          {Boolean(previewClassVideo || videoKey) ? (
                            <React.Fragment key={videoKey}>
                              {loader && (
                                <p className="colorPink">
                                  Processing
                                  <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                  />
                                </p>
                              )}
                              <video
                                className={`img-fluid w-100 vedio ${loader ? "d-none" : ""
                                  }`}
                                controls
                                autoPlay
                                loop
                                onError={handleVideoError}
                                onLoadedData={handleVideoSuccess}
                                controlsList="nodownload"
                              >
                                <source src={classVideo} />
                              </video>
                              <img
                                className={`crossIcon ${loader ? "d-none" : ""
                                  }`}
                                src={Images.whitecross}
                                alt="icon"
                                onClick={(e) => hanldeCrossClassVideo(e)}
                              />
                            </React.Fragment>
                          ) : (
                            <>
                              <label htmlFor="file-15" className="labelNewCase">
                                <span className="file_span">
                                  <img src={Images.downloadicon} />
                                  <br />
                                  <span className="colorPink">Browse</span> and
                                  drag and drop the video file.
                                </span>
                              </label>
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  ""
                )}
                <div className="row mt-4 mb-4">
                  <div className="col-12">
                    <div className="courseFoot">
                      <button
                        className="primaryBtn submitBtn m-0"
                        type="buton"
                        onClick={(e) => updateClasses(e)}
                      >
                        <span>Save</span>
                        {loading && (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditClass;
